import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';

export const Business: React.FC = () => {
	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Join Our Network
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Grow Your Business with Live Rewards
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Are you a business looking to reach more customers? Join the Live Rewards network and gain access to thousands of members actively seeking your products and services.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Why Partner with Live Rewards?
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						• Access to thousands of engaged members
						<br />
						• Increased foot traffic and online sales
						<br />
						• Targeted marketing to local customers
						<br />
						• Flexible discount options
						<br />
						• Real-time analytics and reporting
						<br />• Dedicated account management
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Our Partner Network
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						We work with businesses across all industries:
						<br />
						• Retail & Fashion
						<br />
						• Food & Beverage
						<br />
						• Health & Wellness
						<br />
						• Entertainment & Recreation
						<br />
						• Travel & Hospitality
						<br />• Professional Services
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Get Started
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Ready to grow your business? Contact our business development team to learn more about partnership opportunities.
						<br />
						<br />
						<strong>Email:</strong> business@liverewardsgo.com
						<br />
						<strong>Phone:</strong> 1-800-REWARDS
					</Text>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;
